const { detect } = require('detect-browser');

const browser = detect();

const requiredVersions = {
  chrome: 56,
  firefox: 50,
  ie: 10,
  safari: 10
};

const browserDetails = browser;
// eslint-disable-next-line radix
const outdated = parseInt(browser.version) < requiredVersions[browser.name];

export { requiredVersions, browserDetails, outdated };



// WEBPACK FOOTER //
// ./src/detectBrowser.js